import React from 'react';
import BaseTasksPage from './BaseTasksPage';
import { ProjectPlanTask } from './projectPlanTaskService';
import { NextButton, PreviousButton } from './Buttons';
import useLaunchProjectNavigator from './launchProjectNavigator';

export default function ManageKeyDateTasksPage() {
  const navigator = useLaunchProjectNavigator();

  return (
    <BaseTasksPage
      stepNumber={2}
      filterFunc={(task: ProjectPlanTask) => task.isKeyDate}
      buttons={[
        <PreviousButton
          onClick={navigator.openUpdateProjectPage}
          key="previous-button"
        />,
        <NextButton onClick={navigator.openAllTasksPage} key="next-button" />,
      ]}
      forceShowKeyDatesOnly
    />
  );
}
